<template>
    <div id="edit_scan_action_prototype">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <div v-if="is_loading" class="ui active centered inline loader"></div>
        <div v-else class="ui container">
            <div class="ui segment">
                <h1 class="ui header">
                    {{ scan_action_prorotype.barcode }}{{ scan_action_prorotype.name }}
                </h1>
            </div>
            <table class="ui celled table">
                <thead class="center aligned">
                    <tr>
                        <th class="eight wide">
                            <!-- 欄位名 -->
                            {{ $t('ui.pages.scan_action_prototypes.field_name') }}
                        </th>
                        <th class="eight wide">
                            <!-- 數值 -->
                            {{ $t('ui.pages.scan_action_prototypes.value') }}
                        </th>
                    </tr>
                </thead>
                <tbody class="center aligned ui form">
                    <tr>
                        <td>{{ $t('models.attributes.scan_action_prototypes.barcode') }}</td>
                        <td>
                            <input type="text" name="barcode" v-model="scan_action_prorotype.barcode">
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('models.attributes.scan_action_prototypes.name') }}</td>
                        <td>
                            <input type="text" name="name" v-model="scan_action_prorotype.name">
                        </td>
                    </tr>

                    <tr>
                        <td>{{ $t('models.attributes.scan_action_prototypes.is_default') }}？</td>
                        <td class="left aligned">
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="scan_action_prorotype.is_default">
                                <label></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('models.attributes.scan_action_prototypes.required_condition') }}</td>
                        <td>
                            <input type="text" name="name" v-model="scan_action_prorotype.required_condition">
                            <!-- <select class="ui fluid dropdown" v-dropdown v-model="scan_action_prorotype.required_condition_identity">
                                <option value="">{{ $t('ui.general.please_select') }}</option>
                                <option v-for="status_prototype in condition_status_prototypes" :value="status_prototype.identity">
                                    {{ status_prototype.polarity ? '+ ':'- ' }}{{ status_prototype.name }}
                                </option>
                            </select> -->
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('models.attributes.scan_action_prototypes.required_condition_polarity') }}</td>
                        <td class="left aligned">
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="scan_action_prorotype.required_condition_polarity">
                                <label></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('models.attributes.scan_action_prototypes.before_actions') }}</td>
                        <td>
                            <textarea name="before_actions" rows="8" cols="80" v-model="scan_action_prorotype.before_actions"></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('models.attributes.scan_action_prototypes.description_required_scope') }}</td>
                        <td @click="{ if(objectized_description_required_scope.length <= 0 ) {add_element(objectized_description_required_scope, 'scope_name_0')} }">
                            <div v-for="(scope_name, index) in objectized_description_required_scope">
                                <input
                                    v-model="scope_name.value"
                                    @keyup.delete="remove_element(objectized_description_required_scope, index, 'scope_name_' + (index-1))"
                                    @keydown.enter="add_element(objectized_description_required_scope, 'scope_name_' + (index+1))"
                                    :ref="'scope_name_' + index"
                                >
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('models.attributes.scan_action_prototypes.description_options') }}</td>
                        <td @click="{ if(objectized_description_options.length <= 0 ) {add_element(objectized_description_options, 'description_option_0')} }">
                            <div v-for="(description_option, index) in objectized_description_options">
                                <input
                                    v-model="description_option.value"
                                    @keyup.delete="remove_element(objectized_description_options, index, 'description_option_' + (index-1))"
                                    @keydown.enter="add_element(objectized_description_options, 'description_option_' + (index+1))"
                                    :ref="'description_option_' + index"
                                >
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <table class="ui two column celled table" v-for="(status_prototypes, scope) in scope_grouped_status_prototypes" :status_prototypes="status_prototypes">
                                <thead>
                                    <tr>
                                        <th>{{ human_scope(scope) }}</th>
                                        <th>
                                            <!-- 綁定物料 -->
                                            {{ $t('ui.pages.scan_action_prototypes.binding_material') }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="status_prototype in status_prototypes" :status_prototype="status_prototype">
                                        <td>
                                            <div class="ui checkbox">
                                                <input type="checkbox" :value="status_prototype.identity" v-model="scan_action_prorotype.status_prototype_identities">
                                                <label>
                                                    <i class="plus icon" v-if="status_prototype.polarity == true"></i>
                                                    <i class="minus icon" v-else-if="status_prototype.polarity == false"></i>
                                                    {{ status_prototype.name || '-' }}
                                                </label>
                                            </div>
                                        </td>
                                        <td>{{ status_prototype.material_class_name || $t('ui.general.no') }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            <button class="ui positive basic fluid button" @click.prevent="update_scan_action_prototype">
                {{ $t('ui.general.update') }}
            </button>
        </div>
    </div>
</template>

<script>
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "EditScanActionPrototype",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            scan_action_prorotype: {
                description_required_scope: [],
            },
            status_prototypes: [],
            errors: [],
            objectized_description_required_scope: [],
            objectized_description_options: [],
        }
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
        objectized_description_required_scope: {
            handler(value, oldValue) {
                var result_array = _.map(value, e => {
                    return e.value
                })
                if (this.scan_action_prorotype) {
                    this.scan_action_prorotype.description_required_scope = result_array
                }
            },
            deep: true,
        },
        objectized_description_options: {
            handler(value, oldValue) {
                var result_array = _.map(value, e => {
                    return e.value
                })
                if (this.scan_action_prorotype) {
                    this.scan_action_prorotype.description_options = result_array
                }
            },
            deep: true,
        },
    },
    computed: {
        scope_grouped_status_prototypes() {
            return _.groupBy(this.status_prototypes, 'scope')
        },
        condition_status_prototypes() {
            return _.filter(this.status_prototypes, status_prototype => {
                return status_prototype.scope  == "condition"
            })
        }
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.is_loading = false
                this.scan_action_prorotype = {}
                this.errors = []
                resolve()
            })
            await this.fetch_status_prototypes()
            await this.fetch_scan_action_prototype()
            await new Promise(resolve => {
                this.is_initialized = true
            })
        },
        fetch_scan_action_prototype() {
            this.is_loading = true
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_scan_action_prototype).parse(
                {
                    "scan_action_prototype_identity": this.$route.params.identity,
                },
                ""
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.scan_action_prorotype = response.data.scan_action_prototype
                        this.scan_action_prorotype.status_prototype_identities = _.map(this.scan_action_prorotype.status_prototypes, 'identity')
                        this.objectized_description_required_scope = _.map(this.scan_action_prorotype.description_required_scope, e => {
                            return {"value": e}
                        })
                        this.objectized_description_options = _.map(this.scan_action_prorotype.description_options, e => {
                            return {"value": e}
                        })
                    } else {
                        console.log(response.data)
                        this.$noty.error(response.data)
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    this.$noty.error(error.response)
                })
                .then(() => {
                    setTimeout(() => {
                        this.is_loading = false
                    }, 300)
                })
        },
        fetch_status_prototypes() {
            this.is_loading = true
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_status_prototypes).parse(
                {},
                "?" + object_to_query({
                    pagination: false,
                })
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.status_prototypes = response.data.status_prototypes
                    } else {
                        console.log(response.data)
                        this.$noty.error(response.data)
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    this.$noty.error(error.response)
                })
                .then(() => {
                    this.is_loading = false
                })
        },
        update_scan_action_prototype() {
            this.is_loading = true
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_scan_action_prototype_update).parse(
                {
                    "scan_action_prototype_identity": this.$route.params.identity
                },
                ""
            )
            return axios.post(url, this.scan_action_prorotype, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.$router.push({name: 'scan_action_prototypes'})
                        // this.$noty.success("更新成功")
                        this.$noty.success(
                            this.$t('ui.notifications.success.update__name', {
                                name: this.$t('models.scan_action_prototypes')
                            })
                        )
                    } else {
                        console.log(response.data)
                        this.$noty.error(response.data)
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    this.$noty.error(error.response)
                })
                .then(() => {
                    setTimeout(() => {
                        this.is_loading = false
                    }, 300)
                })
        },
        add_element(target, ref) {
            target.push({value: ""})
            this.$nextTick(() => {
                $(this.$refs[ref]).focus()
            })
        },
        remove_element(target, index, ref) {
            if (target[index].value == "") {
                this.$delete(target, index)
                this.$nextTick(() => {
                    $(this.$refs[ref]).focus()
                })
            }
        },
        human_scope(original_scope) {
            switch (original_scope) {
                case "operator":
                    return "內部貨況(Operator)"
                    break
                case "forwarder":
                    return "客戶貨況(Forwarder)"
                    break
                case "public":
                    return "公開貨況(Public)"
                    break
                case "mark":
                    return "標記(Mark)"
                    break
                case "condition":
                    return "流程控制(Condition)"
                    break
                case "system":
                    return "系統(System)"
                    break
                default:
                    return "不明(Unknown)"
            }
        },
    },
    components: {
        ErrorMessages,
    }
}
</script>
